import { DocumentationItemHeaderV2, defaultDocumentationItemHeaderV2, } from "./item-header-v2";
import { z } from "zod";
export const DocumentationItemConfigurationV2 = z.object({
    showSidebar: z.boolean(),
    isPrivate: z.boolean().optional(),
    isHidden: z.boolean().optional(),
    header: DocumentationItemHeaderV2,
});
export const defaultDocumentationItemConfigurationV2 = {
    header: defaultDocumentationItemHeaderV2,
    isHidden: false,
    isPrivate: false,
    showSidebar: true,
};
